(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    async function refreshDrawer() {
      drawer.classList.add('is-loading');
      try {
        const res = await fetch('/?sections=cart-drawer');
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPanel = doc.querySelector('[data-cart-drawer-panel]');
        const currentPanel = drawer.querySelector('[data-cart-drawer-panel]');
        if (newPanel && currentPanel) currentPanel.innerHTML = newPanel.innerHTML;
        const newCountEl = doc.querySelector('.cart-drawer__count');
        if (newCountEl) {
          const match = newCountEl.textContent.match(/\d+/);
          if (match) {
            document.querySelectorAll('[data-cart-count]').forEach(el => {
              el.textContent = match[0];
              el.dataset.cartCount = match[0];
            });
          }
        }
      } catch (e) {
        console.error('Cart refresh failed', e);
      } finally {
        drawer.classList.remove('is-loading');
      }
    }

    async function changeLine(line, qty) {
      drawer.classList.add('is-loading');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
        });
        if (!res.ok) throw new Error('change failed');
        await refreshDrawer();
      } catch (e) {
        console.error(e);
        drawer.classList.remove('is-loading');
      }
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-toggle]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-drawer-open]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }
      const upd = e.target.closest('[data-cart-update]');
      if (upd) {
        e.preventDefault();
        changeLine(upd.dataset.line, upd.dataset.qty);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const btn = form.querySelector('button[type="submit"]');
      const original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!res.ok) throw new Error('add failed');
        await refreshDrawer();
        openDrawer();
        if (btn) btn.innerHTML = 'Ajouté ✓';
      } catch (err) {
        console.error(err);
        if (btn) btn.innerHTML = 'Erreur';
      } finally {
        setTimeout(() => { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1500);
      }
    }, true);

    window.fluynCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function() {
    document.querySelectorAll('select[data-default]').forEach(sel => {
      if (sel.dataset.default) sel.value = sel.dataset.default;
    });
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-addr-toggle]');
      if (open) {
        const f = document.querySelector('[data-addr-form="' + open.dataset.addrToggle + '"]');
        if (f) f.style.display = f.style.display === 'none' ? '' : 'none';
      }
      const cancel = e.target.closest('[data-addr-cancel]');
      if (cancel) {
        const f = document.querySelector('[data-addr-form="' + cancel.dataset.addrCancel + '"]');
        if (f) f.style.display = 'none';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-copy-url]');
      if (!btn) return;
      const url = btn.dataset.copyUrl;
      navigator.clipboard.writeText(url).then(() => {
        const original = btn.textContent;
        btn.textContent = 'Lien copié ✓';
        setTimeout(() => { btn.textContent = original; }, 1800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    const page = document.querySelector('.cart-page');
    if (!page) return;

    async function refresh() {
      try {
        const res = await fetch(window.location.pathname + '?section_id=' + '{{ section.id }}');
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.cart-page');
        if (fresh) page.innerHTML = fresh.innerHTML;
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.cartCount = cart.item_count; });
      } catch(e) { console.error(e); }
      finally { page.classList.remove('is-loading'); }
    }

    async function changeLine(line, qty) {
      page.classList.add('is-loading');
      try {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(line,10), quantity: parseInt(qty,10) }) });
        await refresh();
      } catch(e) { console.error(e); page.classList.remove('is-loading'); }
    }

    page.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cart-update]');
      if (btn) { e.preventDefault(); changeLine(btn.dataset.line, btn.dataset.qty); }
    });

    let noteTimer;
    page.addEventListener('input', (e) => {
      const note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      }, 600);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    const sort = document.querySelector('[data-collection-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location = url.toString();
      });
    }
    const filterForm = document.querySelector('[data-filter-form]');
    if (filterForm) {
      let t;
      const submitFilters = () => {
        const params = new URLSearchParams();
        filterForm.querySelectorAll('input').forEach(input => {
          if (input.type === 'checkbox' && input.checked) params.append(input.name, input.value);
          else if (input.type === 'number' && input.value) params.set(input.name, input.value);
        });
        const sortEl = document.querySelector('[data-collection-sort]');
        if (sortEl) params.set('sort_by', sortEl.value);
        window.location = window.location.pathname + '?' + params.toString();
      };
      filterForm.addEventListener('change', (e) => {
        if (e.target.type === 'checkbox') submitFilters();
      });
      filterForm.addEventListener('input', (e) => {
        if (e.target.type === 'number') { clearTimeout(t); t = setTimeout(submitFilters, 800); }
      });
    }
    var mqMobileFilters = window.matchMedia('(max-width: 989px)');
    function syncFilterGroups() {
      document.querySelectorAll('.collection__filters .filter-group').forEach(function(d) { d.open = !mqMobileFilters.matches; });
    }
    syncFilterGroups();
    if (mqMobileFilters.addEventListener) { mqMobileFilters.addEventListener('change', syncFilterGroups); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function() {
    const loginView = document.querySelector('[data-login-view]');
    const recoverView = document.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;
    function show(which) {
      loginView.style.display = which === 'recover' ? 'none' : '';
      recoverView.style.display = which === 'recover' ? '' : 'none';
    }
    if (window.location.hash === '#recover' || window.__recoverSuccess) show('recover');
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-recover-toggle]')) { e.preventDefault(); show('recover'); }
      if (e.target.closest('[data-login-toggle]')) { e.preventDefault(); show('login'); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    section.querySelectorAll('video').forEach(function(video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      var setRate = function() { try { video.playbackRate = 1.25; } catch (e) {} };
      setRate();
      video.addEventListener('loadedmetadata', setRate);
      video.addEventListener('play', setRate);
      var tryPlay = function() { var p = video.play(); if (p && p.catch) p.catch(function(){}); };
      if (video.readyState >= 2) tryPlay(); else video.addEventListener('canplay', tryPlay, { once: true });
    });

    var slides = section.querySelectorAll('[data-slide]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    function showSlide(idx) {
      slides.forEach(function(s){ s.classList.toggle('is-active', s.dataset.index === String(idx)); });
      thumbs.forEach(function(t){ t.classList.toggle('is-active', t.dataset.index === String(idx)); });
    }
    thumbs.forEach(function(thumb){ thumb.addEventListener('click', function(){ showSlide(thumb.dataset.index); }); });

    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var stickyPriceEl = section.querySelector('[data-sticky-price]');
    var atcLabel = section.querySelector('[data-atc-label]');
    var atcBtn = section.querySelector('[data-atc-btn]');
    var dataEl = section.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var variantMedia = [];
    try { variantMedia = JSON.parse(section.querySelector('[data-variant-media]').textContent); } catch (e) { variantMedia = []; }
    var variantInventory = [];
    try { variantInventory = JSON.parse(section.querySelector('[data-variant-inventory]').textContent); } catch (e) { variantInventory = []; }
    var stockAlert = section.querySelector('[data-stock-alert]');
    var LOW_STOCK_THRESHOLD = 10;
    function updateStockAlert(variantId) {
      if (!stockAlert) return;
      var inv = null;
      for (var i = 0; i < variantInventory.length; i++) { if (String(variantInventory[i].id) === String(variantId)) { inv = variantInventory[i]; break; } }
      if (inv && inv.tracked && !inv.oversell && inv.qty > 0 && inv.qty <= LOW_STOCK_THRESHOLD) {
        var t = stockAlert.querySelector('[data-stock-alert-text]');
        if (t) t.innerHTML = 'Plus que <strong>' + inv.qty + '</strong> en stock';
        stockAlert.classList.remove('is-hidden');
      } else {
        stockAlert.classList.add('is-hidden');
      }
    }

    var flavorSelect = section.querySelector('[data-flavor-select]');
    var INCLUDED = { 'La Découverte': 1, "L'Essentiel": 3, 'Le Rituel': 5, 'Le Duo': 6 };
    var RECHARGE_PRICE = 790;
    var currentVariantPrice = parseInt(section.dataset.initialPrice, 10) || 0;
    var currentAvailable = section.dataset.initialAvailable === 'true';

    function moneyFormat(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + String.fromCharCode(160) + String.fromCharCode(8364);
    }

    function getN() {
      var f = section.querySelector('.formule-card__input:checked');
      return (f && INCLUDED[f.value]) || 0;
    }
    function getFlavorData() {
      if (!flavorSelect) return [];
      return Array.prototype.slice.call(flavorSelect.querySelectorAll('.flavor-card')).map(function(card){
        return { id: card.dataset.flavor, name: card.dataset.flavorName, qty: parseInt(card.querySelector('[data-flavor-qty]').textContent, 10) || 0, card: card };
      });
    }
    function updateTotalPrice(extraCents) {
      var total = currentVariantPrice + (extraCents || 0);
      if (priceEl) priceEl.textContent = moneyFormat(total);
      if (stickyPriceEl) stickyPriceEl.textContent = moneyFormat(total);
    }
    function updateFlavorUI() {
      if (!flavorSelect) {
        updateTotalPrice(0);
        if (atcLabel) atcLabel.textContent = currentAvailable ? 'Ajouter au panier' : 'Indisponible';
        if (atcBtn) atcBtn.disabled = !currentAvailable;
        return;
      }
      var N = getN();
      var data = getFlavorData();
      var T = data.reduce(function(s,f){ return s + f.qty; }, 0);
      var included = Math.min(T, N);
      var extra = Math.max(0, T - N);
      var counter = flavorSelect.querySelector('[data-flavor-counter]');
      if (counter) counter.textContent = included + ' / ' + N + ' incluses' + (extra > 0 ? ' + ' + extra + ' en plus' : '');
      var prog = flavorSelect.querySelector('[data-flavor-progress]');
      if (prog) prog.style.width = (N > 0 ? (included / N * 100) : 0) + '%';
      var hint = flavorSelect.querySelector('[data-flavor-hint]');
      if (hint) {
        if (T < N) hint.textContent = 'Il te reste ' + (N - T) + ' saveur' + ((N - T) > 1 ? 's' : '') + ' offerte' + ((N - T) > 1 ? 's' : '') + ' à choisir.';
        else if (T === N) hint.textContent = 'Parfait, tes ' + N + ' saveurs incluses sont choisies.';
        else hint.textContent = N + ' incluses + ' + extra + ' saveur' + (extra > 1 ? 's' : '') + ' en supplément.';
      }
      var extraCents = extra * RECHARGE_PRICE;
      var discounted = false;
      if (extra >= 4) { extraCents = Math.round(extraCents * 0.85); discounted = true; }
      var extraEl = flavorSelect.querySelector('[data-flavor-extra]');
      if (extraEl) {
        if (extra > 0) { extraEl.hidden = false; extraEl.textContent = '+ ' + moneyFormat(extraCents) + ' pour tes ' + extra + ' saveur' + (extra > 1 ? 's' : '') + ' en plus' + (discounted ? '  ·  −15% appliqué !' : ''); }
        else { extraEl.hidden = true; }
      }
      data.forEach(function(f){
        f.card.classList.toggle('is-active', f.qty > 0);
        var minus = f.card.querySelector('[data-flavor-minus]');
        if (minus && f.card.dataset.out !== 'true') { minus.disabled = f.qty <= 0; }
      });
      updateTotalPrice(extraCents);
      var ready = N > 0 && T >= N && currentAvailable;
      if (atcBtn) atcBtn.disabled = !ready;
      if (atcLabel) atcLabel.textContent = !currentAvailable ? 'Indisponible' : (ready ? 'Ajouter au panier' : 'Choisis tes ' + N + ' saveurs');
      var sBtn = section.querySelector('[data-sticky-atc-btn]');
      if (sBtn) sBtn.disabled = !ready;
    }

    function selectVariant() {
      var selectedOpts = [];
      section.querySelectorAll('[data-option-block]').forEach(function(block){
        var checked = block.querySelector('[data-option-input]:checked');
        if (checked) selectedOpts.push(checked.value);
      });
      if (selectedOpts.length === 0) { updateFlavorUI(); return; }
      var match = variants.find(function(v){ return selectedOpts.every(function(val, idx){ return v.options[idx] === val; }); });
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      updateStockAlert(match.id);
      currentVariantPrice = match.price;
      currentAvailable = match.available;
      section.querySelectorAll('[data-option-block]').forEach(function(block){
        var checked = block.querySelector('[data-option-input]:checked');
        var target = block.querySelector('[data-option-selected]');
        if (checked && target) target.textContent = checked.value;
      });
      try {
        var vm = variantMedia.find(function(x){ return String(x.id) === String(match.id); });
        if (vm && vm.media) {
          var sl = section.querySelector('[data-media-id="' + vm.media + '"]');
          if (sl) showSlide(sl.dataset.index);
        }
      } catch (e) {}
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      } catch(e) {}
      updateFlavorUI();
    }

    var essenceBlock = section.querySelector('[data-essence-block]');
    var duoBlock = section.querySelector('[data-duo-essence]');
    function updateDuoUI() {
      var fInput = section.querySelector('.formule-card__input:checked');
      var isDuo = fInput && fInput.value === 'Le Duo';
      if (essenceBlock) essenceBlock.style.display = isDuo ? 'none' : '';
      if (duoBlock) {
        duoBlock.hidden = !isDuo;
        duoBlock.querySelectorAll('[data-duo-input]').forEach(function(r){ r.disabled = !isDuo; });
      }
      if (isDuo && essenceBlock) {
        var frene = essenceBlock.querySelector('input[value="Frêne clair"]');
        if (frene && !frene.checked) { frene.checked = true; }
      }
    }

    if (flavorSelect) {
      flavorSelect.addEventListener('click', function(e){
        var plus = e.target.closest('[data-flavor-plus]');
        var minus = e.target.closest('[data-flavor-minus]');
        if (!plus && !minus) return;
        var card = e.target.closest('.flavor-card');
        if (!card) return;
        if (card.dataset.out === 'true') return;
        var qtyEl = card.querySelector('[data-flavor-qty]');
        var q = parseInt(qtyEl.textContent, 10) || 0;
        if (plus && q < 12) q++;
        if (minus && q > 0) q--;
        qtyEl.textContent = q;
        updateFlavorUI();
      });
    }

    section.querySelectorAll('[data-option-input]').forEach(function(input){
      input.addEventListener('change', function(){ updateDuoUI(); selectVariant(); });
    });
    updateDuoUI();
    selectVariant();

    var productForm = section.querySelector('#product-form-main');
    if (productForm && flavorSelect) {
      productForm.addEventListener('submit', function(e){
        e.preventDefault();
        var N = getN();
        var data = getFlavorData().filter(function(f){ return f.qty > 0; });
        var T = data.reduce(function(s,f){ return s + f.qty; }, 0);
        if (N === 0 || T < N) { updateFlavorUI(); return; }
        var freeLeft = N;
        var included = [];
        var extras = [];
        data.forEach(function(f){
          var free = Math.min(f.qty, freeLeft);
          var paid = f.qty - free;
          freeLeft -= free;
          if (free > 0) included.push(f.name + ' ×' + free);
          if (paid > 0) extras.push({ id: parseInt(f.id, 10), quantity: paid });
        });
        var props = { 'Saveurs incluses': included.join(', ') };
        var duoChecked = section.querySelector('[data-duo-input]:checked:not([disabled])');
        if (duoChecked) props['Essences du Duo'] = duoChecked.value;
        var items = [{ id: parseInt(variantInput.value, 10), quantity: 1, properties: props }];
        extras.forEach(function(x){ items.push(x); });
        var lbl = section.querySelector('[data-atc-label]');
        var prev = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = 'Ajout…';
        if (atcBtn) atcBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function(res){ if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function(){ window.location = '/cart'; })
          .catch(function(err){ console.error(err); if (lbl) lbl.textContent = 'Erreur, réessaie'; if (atcBtn) atcBtn.disabled = false; setTimeout(function(){ if (lbl) lbl.textContent = prev; }, 2000); });
      });
    }

    var qtyInput = section.querySelector('[data-qty-input]');
    section.querySelectorAll('[data-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var current = parseInt(qtyInput.value, 10) || 1;
        var step = parseInt(btn.dataset.qtyStep, 10);
        qtyInput.value = Math.max(1, current + step);
      });
    });

    var stickyAtc = section.querySelector('[data-sticky-atc]');
    var mainAtc = section.querySelector('.product-form__submit');
    if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries){
        var visible = entries[0].isIntersecting;
        stickyAtc.classList.toggle('is-visible', !visible);
      }, { rootMargin: '-80px 0px 0px 0px' });
      observer.observe(mainAtc);
    }
    var stickyBtn = section.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn && mainAtc) {
      stickyBtn.addEventListener('click', function(){
        if (stickyBtn.disabled) return;
        var form = mainAtc.closest('form');
        if (form) { form.requestSubmit ? form.requestSubmit(mainAtc) : form.submit(); }
      });
    }

    var shipCutoff = section.querySelector('[data-ship-cutoff]');
    var shipText = section.querySelector('[data-ship-cutoff-text]');
    function parisParts() {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(p){ o[p.type] = p.value; });
      var dayMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
      return { h: parseInt(o.hour, 10), m: parseInt(o.minute, 10), day: dayMap[o.weekday] };
    }
    function nextBusinessDay(day) {
      var names = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      var n = day;
      do { n = (n + 1) % 7; } while (n === 0 || n === 6);
      return names[n];
    }
    function updateShipCutoff() {
      if (!shipCutoff || !shipText) return;
      var p = parisParts();
      if (typeof p.day !== 'number' || isNaN(p.h)) { return; }
      var CUTOFF = 14;
      if (p.day >= 1 && p.day <= 5 && p.h < CUTOFF) {
        var rem = (CUTOFF - p.h) * 60 - p.m;
        var rh = Math.floor(rem / 60), rm = rem % 60;
        var left = rh > 0 ? (rh + 'h' + (rm < 10 ? '0' + rm : rm)) : (rm + ' min');
        shipText.innerHTML = 'Commandez dans les <strong>' + left + '</strong> → expédié aujourd’hui';
      } else {
        shipText.innerHTML = 'Commandez maintenant → expédié <strong>' + nextBusinessDay(p.day) + '</strong>';
      }
      shipCutoff.hidden = false;
    }
    updateShipCutoff();
    setInterval(updateShipCutoff, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('[data-bundle]');
    if (!root) return;
    const discount = parseFloat(root.dataset.discount) || 0;
    const subtotalEl = root.querySelector('[data-bundle-subtotal]');
    const savedEl = root.querySelector('[data-bundle-saved]');
    const finalEl = root.querySelector('[data-bundle-final]');
    const addBtn = root.querySelector('[data-bundle-add]');
    function moneyFormat(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac'; }
    function recompute() {
      let subtotal = 0;
      root.querySelectorAll('[data-bundle-check]:checked').forEach(input => { subtotal += parseInt(input.dataset.price, 10) || 0; });
      const saved = Math.round(subtotal * discount / 100);
      const final = subtotal - saved;
      if (subtotalEl) subtotalEl.textContent = moneyFormat(subtotal);
      if (savedEl) savedEl.textContent = moneyFormat(saved);
      if (finalEl) finalEl.textContent = moneyFormat(final);
      if (addBtn) addBtn.disabled = subtotal === 0;
    }
    root.querySelectorAll('[data-bundle-check]').forEach(input => { input.addEventListener('change', recompute); });
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [];
        root.querySelectorAll('[data-bundle-check]:checked').forEach(input => { items.push({ id: parseInt(input.dataset.variantId, 10), quantity: 1 }); });
        if (items.length === 0) return;
        const originalText = addBtn.innerHTML;
        addBtn.disabled = true; addBtn.innerHTML = 'Ajout…';
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          if (!res.ok) throw new Error('add failed');
          if (window.fluynCart) { await window.fluynCart.refresh(); window.fluynCart.open(); }
          addBtn.innerHTML = 'Ajouté ✓';
        } catch(e) { console.error(e); addBtn.innerHTML = 'Erreur'; }
        finally { setTimeout(() => { addBtn.disabled = false; addBtn.innerHTML = originalText; recompute(); }, 1500); }
      });
    }
    recompute();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const containers = document.querySelectorAll('[data-recommendations]');
    containers.forEach(container => {
      if (container.querySelector('.recommendations__grid')) return;
      const url = container.dataset.url;
      if (!url) return;
      fetch(url)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh) container.innerHTML = fresh.innerHTML;
        })
        .catch(e => console.error('Recommendations failed', e));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recharge-builder"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var s = document.querySelector('[data-rb]');
    if (!s) return;
    var variantInput = s.querySelector('[data-rb-variant]');
    var priceEl = s.querySelector('[data-rb-price]');
    var unitEl = s.querySelector('[data-rb-unit]');
    var atcBtn = s.querySelector('[data-rb-atc]');
    var atcLabel = s.querySelector('[data-rb-atc-label]');
    var counter = s.querySelector('[data-rb-counter]');
    var progress = s.querySelector('[data-rb-progress]');
    var hint = s.querySelector('[data-rb-hint]');
    var flavorsWrap = s.querySelector('.rb__flavors');
    var rbVariants = [];
    try { rbVariants = JSON.parse(s.querySelector('[data-rb-variants]').textContent); } catch (e) { rbVariants = []; }

    function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + String.fromCharCode(160) + String.fromCharCode(8364); }
    function fmtInput() { return s.querySelector('[data-rb-format]:checked'); }
    function currentN() { var f = fmtInput(); return f ? (parseInt(f.dataset.rbN, 10) || 1) : 1; }
    function flavorEls() { return Array.prototype.slice.call(s.querySelectorAll('.rb__flavor')); }
    function total() { return flavorEls().reduce(function(a, el){ return a + (parseInt(el.querySelector('[data-rb-qty]').textContent, 10) || 0); }, 0); }

    function applyFormat() {
      var f = fmtInput();
      var fmt = f ? f.value : null;
      var N = currentN();
      var v = null;
      for (var i = 0; i < rbVariants.length; i++) { if (rbVariants[i].format === fmt) { v = rbVariants[i]; break; } }
      if (v) {
        if (variantInput) variantInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (unitEl) unitEl.textContent = N > 1 ? ('soit ' + money(Math.round(v.price / N)) + ' / saveur') : '';
      }
      flavorEls().forEach(function(el){ el.querySelector('[data-rb-qty]').textContent = '0'; el.classList.remove('is-active'); });
      updateUI();
    }

    function updateUI() {
      var N = currentN();
      var T = total();
      if (counter) counter.textContent = T + ' / ' + N;
      if (progress) progress.style.width = (N > 0 ? (Math.min(T, N) / N * 100) : 0) + '%';
      if (hint) { if (T < N) hint.textContent = 'Choisis encore ' + (N - T) + ' saveur' + ((N - T) > 1 ? 's' : '') + '.'; else hint.textContent = 'Parfait, ton pack est complet !'; }
      flavorEls().forEach(function(el){
        var q = parseInt(el.querySelector('[data-rb-qty]').textContent, 10) || 0;
        el.classList.toggle('is-active', q > 0);
        var minus = el.querySelector('[data-rb-minus]');
        if (minus && el.dataset.rbOut !== 'true') minus.disabled = q <= 0;
      });
      var ready = N > 0 && T === N;
      if (atcBtn) atcBtn.disabled = !ready;
      if (atcLabel) atcLabel.textContent = ready ? 'Ajouter au panier' : ('Choisis tes ' + N + ' saveurs');
    }

    s.querySelectorAll('[data-rb-format]').forEach(function(r){ r.addEventListener('change', applyFormat); });

    if (flavorsWrap) {
      flavorsWrap.addEventListener('click', function(e){
        var plus = e.target.closest('[data-rb-plus]');
        var minus = e.target.closest('[data-rb-minus]');
        if (!plus && !minus) return;
        var el = e.target.closest('.rb__flavor');
        if (!el || el.dataset.rbOut === 'true') return;
        var qEl = el.querySelector('[data-rb-qty]');
        var q = parseInt(qEl.textContent, 10) || 0;
        var N = currentN();
        if (plus && total() < N) q++;
        if (minus && q > 0) q--;
        qEl.textContent = q;
        updateUI();
      });
    }

    var form = s.querySelector('#rb-form');
    if (form) {
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var N = currentN();
        if (total() !== N) { updateUI(); return; }
        var parts = [];
        flavorEls().forEach(function(el){ var q = parseInt(el.querySelector('[data-rb-qty]').textContent, 10) || 0; if (q > 0) parts.push(el.dataset.rbFlavorName + ' ' + String.fromCharCode(215) + q); });
        var item = { id: parseInt(variantInput.value, 10), quantity: 1, properties: { 'Saveurs': parts.join(', ') } };
        var prev = atcLabel ? atcLabel.textContent : '';
        if (atcLabel) atcLabel.textContent = 'Ajout' + String.fromCharCode(8230);
        if (atcBtn) atcBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function(){ window.location = '/cart'; })
          .catch(function(err){ console.error(err); if (atcLabel) atcLabel.textContent = 'Erreur, réessaie'; if (atcBtn) atcBtn.disabled = false; setTimeout(function(){ if (atcLabel) atcLabel.textContent = prev; }, 2000); });
      });
    }

    applyFormat();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  (function() {
    const drawer = document.querySelector('.search-drawer[data-drawer="search"]');
    if (!drawer) return;
    const input = drawer.querySelector('[data-search-input]');
    const results = drawer.querySelector('[data-predictive-results]');

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-open="search"]')) {
        setTimeout(() => { if (input) input.focus(); }, 350);
      }
      if (e.target.closest('[data-search-close]')) {
        e.preventDefault();
        close();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    let timer, controller;
    if (input) {
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { results.innerHTML = ''; drawer.classList.remove('has-results'); return; }
        timer = setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          try {
            const url = '/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=6';
            const res = await fetch(url, { signal: controller.signal });
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = fresh ? fresh.innerHTML : '';
            drawer.classList.add('has-results');
          } catch (err) { if (err.name !== 'AbortError') console.error(err); }
        }, 250);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
